import React from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { Switch } from "@/components/ui/switch";
import { Sun, Moon, Keyboard, Bell } from "lucide-react";

export default function Settings() {
    const { theme, setTheme } = useTheme();

    return (
        <div className="max-w-2xl space-y-8" data-testid="settings-page">
            <header>
                <div className="mono-label">Settings</div>
                <h1 className="font-display text-4xl font-medium tracking-tight mt-2">Preferences</h1>
                <p className="text-muted-foreground mt-1">Tune StudySphere the way you like.</p>
            </header>

            <section className="bg-card rounded-2xl border border-border/60 p-6 space-y-5">
                <h3 className="font-display font-medium text-lg">Appearance</h3>
                <Row icon={theme === "dark" ? Moon : Sun} label="Dark mode" hint="Switch between light and dark themes.">
                    <Switch checked={theme === "dark"} onCheckedChange={(v) => setTheme(v ? "dark" : "light")} data-testid="settings-dark-mode" />
                </Row>
            </section>

            <section className="bg-card rounded-2xl border border-border/60 p-6">
                <h3 className="font-display font-medium text-lg mb-4">Keyboard shortcuts</h3>
                <ul className="text-sm space-y-3">
                    <ShortcutRow keys={["⌘", "K"]} desc="Open command palette" />
                    <ShortcutRow keys={["⌘", "J"]} desc="Toggle AI assistant" />
                    <ShortcutRow keys={["Enter"]} desc="Send AI message" />
                </ul>
            </section>

            <section className="bg-card rounded-2xl border border-border/60 p-6">
                <h3 className="font-display font-medium text-lg mb-2">Notifications</h3>
                <p className="text-sm text-muted-foreground">In-app toasts are enabled by default. Push notifications coming soon.</p>
            </section>
        </div>
    );
}

function Row({ icon: Icon, label, hint, children }) {
    return (
        <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center"><Icon className="w-4 h-4" /></div>
                <div>
                    <div className="text-sm font-medium">{label}</div>
                    <div className="text-xs text-muted-foreground">{hint}</div>
                </div>
            </div>
            {children}
        </div>
    );
}

function ShortcutRow({ keys, desc }) {
    return (
        <li className="flex items-center justify-between">
            <span className="text-foreground/80">{desc}</span>
            <span className="flex gap-1">{keys.map(k => <span key={k} className="kbd">{k}</span>)}</span>
        </li>
    );
}
